import { WifiOff, RefreshCw } from 'lucide-react';

interface OfflineBannerProps {
  isOnline: boolean;
  wasOffline: boolean;
  onSync: () => void;
}

export default function OfflineBanner({ isOnline, wasOffline, onSync }: OfflineBannerProps) {
  if (isOnline && !wasOffline) return null;

  return (
    <div className={`rounded-xl px-4 py-3 mb-6 flex items-center gap-3 ${isOnline ? 'bg-emerald-500/10 border border-emerald-500/20' : 'bg-amber-500/10 border border-amber-500/20'}`}>
      <WifiOff className={`w-5 h-5 ${isOnline ? 'text-emerald-400' : 'text-amber-400'}`} />
      <div className="flex-1">
        <p className={`text-sm font-medium ${isOnline ? 'text-emerald-400' : 'text-amber-400'}`}>
          {isOnline ? 'Back online' : 'Working offline'}
        </p>
        <p className="text-xs text-navy-400">
          {isOnline ? 'Data will sync automatically.' : 'Surveys are saved locally and will sync when connection returns.'}
        </p>
      </div>
      {isOnline && (
        <button type="button" onClick={onSync} className="p-2 hover:bg-emerald-500/20 rounded-lg transition-colors">
          <RefreshCw className="w-4 h-4 text-emerald-400" />
        </button>
      )}
    </div>
  );
}
